<template>
  <div class="app-sidebar sidebar-shadow">
    <div class="app-header__logo">
      <div class="logo-src"></div>
      <div class="header__pane ml-auto">
        <div>
          <button
            type="button"
            class="hamburger close-sidebar-btn hamburger--elastic"
            data-class="closed-sidebar"
          >
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="app-header__mobile-menu">
      <div>
        <button
          type="button"
          class="hamburger hamburger--elastic mobile-toggle-nav"
        >
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
      </div>
    </div>
    <div class="app-header__menu">
      <span>
        <button
          type="button"
          class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav"
        >
          <span class="btn-icon-wrapper">
            <i class="fa fa-ellipsis-v fa-w-6"></i>
          </span>
        </button>
      </span>
    </div>
    <div class="scrollbar-sidebar">
      <div class="app-sidebar__inner">
        <ul class="vertical-nav-menu">
          <li class="app-sidebar__heading">Menu</li>
          <li>
            <router-link :to="{ name: 'Home' }">
              <i class="fas fa-home metismenu-icon"></i>
              Inicio
            </router-link>
          </li>
          <li :class="[currentPage.includes('ventas') ? 'mm-active' : '']">
            <a href="#">
              <i class="fas fa-dollar-sign metismenu-icon"></i>
              Ventas
              <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
            </a>
            <ul
              :class="[
                currentPage.includes('ventas')
                  ? 'mm-collapse mm-show'
                  : 'mm-collapse',
              ]"
            >
              <li>
                <router-link :to="{ name: 'ListarVentas' }"
                  >Listado de movimientos</router-link
                >
              </li>
              <li :class="[isAdmin ? '' : 'd-none']">
                <router-link :to="{ name: 'NuevoComprobante' }"
                  >Nuevo comprobante</router-link
                >
              </li>
              <li :class="[isAdmin ? '' : 'd-none']">
                <router-link :to="{ name: 'NuevoRecibo' }"
                  >Nuevo recibo</router-link
                >
              </li>
              <li :class="[isAdmin ? '' : 'd-none']">
                <router-link :to="{ name: 'AnularComprobante' }"
                  >Anular comprobante</router-link
                >
              </li>
              <li :class="[isAdmin ? '' : 'd-none']">
                <a href="#" @click="openModalExportIVA = true"
                  >Exportar IVA ventas</a
                >
              </li>
            </ul>
          </li>
          <li v-if="isAdmin">
            <router-link :to="{ name: 'Reportes' }">
              <i class="fas fa-file-invoice metismenu-icon"></i>
              Impresiones y listados
            </router-link>
          </li>
          <li :class="[currentPage.includes('pedidos') ? 'mm-active' : '']">
            <a href="#">
              <i class="fas fa-file-powerpoint metismenu-icon"></i>
              Pedidos
              <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
            </a>
            <ul
              :class="[
                currentPage.includes('pedidos')
                  ? 'mm-collapse mm-show'
                  : 'mm-collapse',
              ]"
            >
              <li v-if="isAdmin">
                <router-link
                  :to="{ name: 'ListarPedidosPendientes' }"
                  class="text-danger"
                  >Pedidos Pendientes</router-link
                >
              </li>
              <li v-if="!isAdmin">
                <router-link :to="{ name: 'HistorialPedidos' }"
                  >Historial de pedidos</router-link
                >
              </li>
              <li v-if="isAdmin">
                <router-link :to="{ name: 'ListarPedidos' }"
                  >Pedidos realizados</router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'NuevoPedido' }"
                  >Nuevo pedido</router-link
                >
              </li>
            </ul>
          </li>
          <li
            :class="[currentPage.includes('estadisticas') ? 'mm-active' : '']"
          >
            <a href="#">
              <i class="fas fa-chart-line metismenu-icon"></i>
              Estadísticas
              <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
            </a>
            <ul
              :class="[
                currentPage.includes('estadisticas')
                  ? 'mm-collapse mm-show'
                  : 'mm-collapse',
              ]"
            >
              <li>
                <router-link :to="{ name: 'EstadisticasPersonales' }"
                  >Estadísticas personales</router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'VentasPorArticulo' }"
                  >Ventas por artículo</router-link
                >
              </li>
              <li v-if="isAdmin">
                <router-link :to="{ name: 'EstadisticasGenerales' }"
                  >Estadísticas generales</router-link
                >
              </li>
              <li v-if="isAdmin">
                <router-link :to="{ name: 'EstadisticasPorEmpleado' }"
                  >Estadísticas empleados</router-link
                >
              </li>
              <li v-if="isAdmin">
                <router-link :to="{ name: 'EstadisticasPorArticulo' }"
                  >Estadísticas artículos</router-link
                >
              </li>
            </ul>
          </li>
          <li :class="[currentPage.includes('articulos') ? 'mm-active' : '']">
            <a href="#">
              <i class="fas fa-boxes metismenu-icon"></i>
              Articulos
              <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
            </a>
            <ul
              :class="[
                currentPage.includes('articulos')
                  ? 'mm-collapse mm-show'
                  : 'mm-collapse',
              ]"
            >
              <li>
                <router-link :to="{ name: 'ListarArticulos' }"
                  >Listado de Articulos</router-link
                >
              </li>
              <li>
                <router-link
                  :class="isAdmin ? '' : 'd-none'"
                  :to="{ name: 'NuevoArticulo' }"
                  >Nuevo artículo</router-link
                >
              </li>
              <li>
                <router-link
                  :class="isAdmin ? '' : 'd-none'"
                  :to="{ name: 'ActualizarStock' }"
                  >Actualizar stock</router-link
                >
              </li>
              <li>
                <router-link
                  :class="isAdmin ? '' : 'd-none'"
                  :to="{ name: 'AplicarAumento' }"
                  >Aplicar aumentos</router-link
                >
              </li>
              <li>
                <router-link
                  :class="isAdmin ? '' : 'd-none'"
                  :to="{ name: 'AumentoGeneral' }"
                  >Aumento general</router-link
                >
              </li>
              <li>
                <a
                  style="cursor:pointer"
                  :class="isAdmin ? '' : 'd-none'"
                  href="#"
                  @click="openModalCapitalizacion = true"
                  >Ver capital</a
                >
              </li>
            </ul>
          </li>
          <li
            :class="[
              currentPage.includes('clientes') ? 'mm-active' : '',
              isAdmin ? '' : 'd-none',
            ]"
          >
            <a href="#">
              <i class="fas fa-users metismenu-icon"></i>
              Clientes
              <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
            </a>
            <ul
              :class="[
                currentPage.includes('clientes')
                  ? 'mm-collapse mm-show'
                  : 'mm-collapse',
              ]"
            >
              <li>
                <router-link :to="{ name: 'ListarClientes' }"
                  >Listado de Clientes</router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'NuevoCliente' }"
                  >Nuevo Cliente</router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'AgregarSaldoAnterior' }"
                  >Agregar saldo pendiente</router-link
                >
              </li>
            </ul>
          </li>
          <li
            :class="[
              currentPage.includes('repartos') ? 'mm-active' : '',
              isAdmin ? '' : 'd-none',
            ]"
          >
            <a href="#">
              <i class="fas fa-truck metismenu-icon"></i>
              Repartos
              <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
            </a>
            <ul
              :class="[
                currentPage.includes('repartos')
                  ? 'mm-collapse mm-show'
                  : 'mm-collapse',
              ]"
            >
              <li>
                <router-link :to="{ name: 'ListarRepartos' }"
                  >Listado de repartos</router-link
                >
              </li>
            </ul>
          </li>
          <li
            :class="[
              parametrosSistema ? 'mm-active' : '',
              isAdmin ? '' : 'd-none',
            ]"
          >
            <a href="#">
              <i class="fas fa-cogs metismenu-icon"></i>
              Parametros del sistema
              <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
            </a>
            <ul
              :class="[
                parametrosSistema ? 'mm-collapse mm-show' : 'mm-collapse',
              ]"
            >
              <li>
                <router-link :to="{ name: 'ListarFamilias' }"
                  >Familias</router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'ListarMarcas' }">Marcas</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'ListarRepartidores' }"
                  >Repartidores</router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'ListarUsuarios' }"
                  >Empleados</router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'ListarObjetivos' }"
                  >Objetivos</router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'ListarListas' }">Listas</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <ModalExportarIVA
      v-if="openModalExportIVA"
      @cerrarExportIVA="openModalExportIVA = false"
    />
    <ModalCapitalizacion
      v-if="openModalCapitalizacion"
      @cerrarModalCapitalizacion="openModalCapitalizacion = false"
    />
  </div>
</template>
<script>
import PerfectScrollbar from "perfect-scrollbar";
import { mapGetters } from "vuex";
import $ from "jquery";
import axios from "axios";
import Swal from "sweetalert2";
import "metismenu";
import ModalExportarIVA from "@/components/layouts/modalExportarIva.vue";
import ModalCapitalizacion from "@/components/views/capitalizacion/ModalCapitalizacion.vue";
export default {
  name: "SidebarComponent",
  components: { ModalCapitalizacion, ModalExportarIVA },
  data() {
    return {
      isAdmin: false,
      urlIVA: "",
      openModalExportIVA: false,
      openModalCapitalizacion: false,
    };
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),
    currentPage() {
      return this.$route.path;
    },
    parametrosSistema() {
      return (
        this.currentPage.includes("objetivos") ||
        this.currentPage.includes("marcas") ||
        this.currentPage.includes("familias") ||
        this.currentPage.includes("repartidores") ||
        this.currentPage.includes("usuarios")
      );
    },
  },
  watch: {
    user: function() {
      this.isAdmin = this.user.tipo === "Administrador";
      console.log(this.isAdmin, "isadmin");
    },
  },
  mounted() {
    this.urlIVA = axios.defaults.baseURL + "/iva-ventas";
    //dropdown de los items del sidebar
    setTimeout(function() {
      $(".vertical-nav-menu").metisMenu();
    }, 1);
    //scroll del sidebar
    setTimeout(function() {
      if ($(".scrollbar-container")[0]) {
        new PerfectScrollbar(".scrollbar-sidebar", {
          wheelSpeed: 2,
          wheelPropagation: true,
          minScrollbarLength: 20,
        });
      }
    }, 1000);

    $(".drawer-nav-btn").click(function() {
      $(".app-drawer-wrapper").removeClass("drawer-open");
      $(".app-drawer-overlay").addClass("d-none");
      $(".open-right-drawer").removeClass("is-active");
    });

    $(".app-drawer-overlay").click(function() {
      $(this).addClass("d-none");
      $(".app-drawer-wrapper").removeClass("drawer-open");
      $(".open-right-drawer").removeClass("is-active");
    });

    $(".mobile-toggle-nav").click(function() {
      $(this).toggleClass("is-active");
      $(".app-container").toggleClass("sidebar-mobile-open");
    });

    $(".mobile-toggle-header-nav").click(function() {
      $(this).toggleClass("active");
      $(".app-header__content").toggleClass("header-mobile-open");
    });

    $(".mobile-app-menu-btn").click(function() {
      $(".hamburger", this).toggleClass("is-active");
      $(".app-inner-layout").toggleClass("open-mobile-menu");
    });
    this.isAdmin = this.user.tipo === "Administrador";
  },
  methods: {
    capitalizacion() {
      axios.get("capitalizacion").then((res) => {
        if (res.data.success) {
          Swal.fire({
            icon: "info",
            title: `Capital total: $${this.$options.filters.numFormat(
              res.data.capitalizacion,
              "0,0.00",
            )}`,
          });
        }
      });
    },
  },
};
</script>
